import { formatDuration } from '../../utils/metricsFormat';

/** Card p50/p85 — cycle time e lead time do quadro (percentilesSql, M6a). */
export default function PercentileStat({ label, stat, hint }) {
  const hasData = (stat?.n ?? 0) > 0;
  return (
    <div className="bg-main border border-border/50 rounded-lg p-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] uppercase tracking-wider text-text-secondary font-semibold">{label}</span>
        {hasData && <span className="text-[10px] text-text-secondary/70">n={stat.n}</span>}
      </div>
      {hasData ? (
        <div className="flex items-baseline gap-4">
          <div>
            <div className="text-lg font-semibold text-text-primary">{formatDuration(stat.p50_ms)}</div>
            <div className="text-[10px] text-text-secondary">mediana (p50)</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-text-primary">{formatDuration(stat.p85_ms)}</div>
            <div className="text-[10px] text-text-secondary">p85</div>
          </div>
        </div>
      ) : (
        <div className="text-xs text-text-secondary py-1">Sem dados suficientes no período.</div>
      )}
      {hint && <div className="text-[10px] text-text-secondary/70 mt-1.5">{hint}</div>}
    </div>
  );
}
